import {Button} from "../components/ui/Button";
import React, {useState} from "react";
import {Library} from "./Library";
import {
    LucideDownloadCloud,
    LucideGem, 
    LucideLibrary,
    LucideSettings2,
    LucideShoppingCart
} from "lucide-react";
import {useCreditModal} from "../context/CreditModalContext";
import {UserAvatar} from "../components/layout/AppHeader";
import { AccountSettings } from "../components/common/AccountSettings";


interface AccountOptionProps {
    
}


export const Account = () => {
    const [showLibrary, setShowLibrary] = useState(true);
    return(
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
            
            <div className="flex flex-col lg:flex-row lg:gap-8">
                
                <SidebarLeft showLibrary={showLibrary} setShowLibrary={setShowLibrary} />
                {showLibrary ? <Library /> : <AccountSettings />}
                
            </div>
            
        </div>
    );
};

{/* make Credit Balance card red if 0 credits?? --todo */}
const SidebarLeft = ({showLibrary, setShowLibrary}: {
    showLibrary: boolean;
    setShowLibrary: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    return (
        <aside id="account-hub"  className="w-full lg:w-1/4 lg:col-span-3 flex-shrink-0 lg:sticky lg:top-8 self-start">
            <div className="space-y-6">

                <CreditBalanceCard />

                <div className="bg-surface-950 p-5 rounded-xl border border-surface-800 space-y-6">
                    <div className="flex items-center gap-4">
                        <UserAvatar />
                        <div>
                            <h4 className="font-bold text-lg text-surface-300">Lisa Paradise</h4>
                            <p className="text-sm text-surface-500">lisa.paradise@example.com</p>
                        </div>
                    </div>
                    <div className="space-y-3">

                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowLibrary(true);
                            }}
                            className={`flex items-center gap-3 font-medium transition-colors  ${
                                showLibrary ? 'text-brand-500' : 'text-surface-400 hover:text-brand-500'
                            }`}
                        >
                            <LucideLibrary className="w-5 h-5"/>
                            Library
                        </a>

                        <a href="#"
                           onClick={(e) => {
                                e.preventDefault();
                                setShowLibrary(false);
                            }}
                            className={`flex items-center gap-3 font-medium transition-colors ${
                                !showLibrary ? 'text-brand-500' : 'text-surface-400 hover:text-brand-500'
                            }`}
                        >
                            <LucideSettings2 className="w-5 h-5"/>
                            Account Settings
                        </a>

                    </div>
                </div>

                <div className="bg-surface-950 p-5 rounded-xl border border-surface-800">

                    <div className="font-bold text-lg text-surface-300 list-none cursor-pointer flex justify-between items-center">
                        Billing History
                    </div>

                    <ul className="mt-4 space-y-3 text-sm text-surface-300">

                        <BillingItem
                            purchaseDate="Jul 23, 2025"
                            price="$49.99"
                            creditPackName="Credits (100)"
                        />

                        <BillingItem
                            purchaseDate="Dec 31, 2024"
                            price="$49.99"
                            creditPackName="Credits (100)"
                        />

                        <BillingItem
                            purchaseDate="Oct 12, 2023"
                            price="$29.99"
                            creditPackName="Credits (50)"
                        />

                    </ul>
                </div>

            </div>
        </aside>
    );
};

const CreditBalanceCard = () => {
    const {openModal} = useCreditModal();
    const creditBalance = 0;
    
    return (
        <div className={"relative overflow-hidden p-6 rounded-xl bg-gradient-to-br to-surface-900 " +
            `text-white shadow-lg animate-gradient shadow-glow-inner 
            ${creditBalance > 0 ? 'from-brand-800 via-brand-950' : 'from-red-800 via-red-950'}`}>

            <div className="flex flex-col h-full">
                <h5 className="font-semibold text-brand-200">Credit Balance</h5>
                <div className="my-4 flex items-center gap-3">
                    <LucideGem className="w-12 h-12"/>
                    <span className="text-5xl font-bold tracking-tight text-surface-100">
                        {creditBalance}
                    </span>
                </div>

                <Button
                    intent="primary"
                    size="large"
                    glow={true}
                    hover={true}
                    onClick={() => openModal()}
                    className={"border text-brand-400 border-brand-400 bg-[transparent] mt-6"}
                >
                    <LucideShoppingCart className="w-6 h-6 mr-2"/>
                    Buy credits
                </Button>

            </div>
        </div>
    );
};


interface BillingItemProps {
    purchaseDate: string;
    creditPackName: string;
    price: string;
}


const BillingItem = ({purchaseDate, creditPackName, price}: BillingItemProps) => {
    function downloadInvoice() {
        alert('JE MAG HIER 100!!')
    }

    return (
        <li className="flex justify-between items-center -mx-1 rounded-md hover:bg-surface-800 transition-colors">

            <div className="flex items-center gap-2">
                <span className="text-surface-400 mr-2">{purchaseDate}</span>
                <span className="mr-4">{creditPackName}</span>
                <span className="font-semibold text-surface-300">{price}</span>
            </div>

            <Button
                intent="icon"
                size="xSmall"
                className="text-surface-500 hover:text-brand-500"
                onClick={() => downloadInvoice()}
            >
                <LucideDownloadCloud className="w-4 h-4"/>
            </Button>

        </li>
    );
};


const TabNavigation = () => {
    return (
        <div className="border-b border-surface-200">
            <nav
                className="-mb-px flex space-x-6"
                aria-label="Tabs"
                id="dashboard-tabs"
            >
                <button
                    data-tab-target="#asset-library-view"
                    className="tab-button active-tab whitespace-nowrap border-b-2 py-4 px-1 text-sm font-semibold border-brand-500 text-brand-600"
                    aria-current="page"
                >
                    My Asset Library
                </button>
                <button
                    data-tab-target="#billing-history-view"
                    className="tab-button whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium border-transparent text-surface-500 hover:border-surface-300 hover:text-surface-700"
                >
                    Billing History
                </button>
                <button
                    data-tab-target="#purchase-credits-view"
                    className="tab-button whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium border-transparent text-surface-500 hover:border-surface-300 hover:text-surface-700"
                >
                    Purchase Credits
                </button>
            </nav>
        </div>
    );
};


interface TabProps {
    title: string;
}

const TabButton = () => {
    return (
        <Button
            className="tab-button whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium border-transparent 
           text-surface-500 hover:border-surface-300 hover:text-surface-700">

        </Button>
    );
};


const TabContent = () => {
    return (
        <div></div>
    );
};















